import { useWatch } from 'react-hook-form';
import { lt } from '@mews/framework';
import { DividerList, ContentSection } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { SettlementConfigurationFields, LocalPolicyFields } from '../../fields';
import { RateGroupFormValues } from '../../../../schemas';
import { SettlementConfigurationsFieldName } from '../../types';
import { LocalCreatePolicyLinks } from '../../DefaultPolicyForm/LocalCreatePolicyLinks';

export const RateGroupFormPaymentPoliciesFields = () => {
    const selectedCurrency = useWatch<RateGroupFormValues>({
        name: SettlementConfigurationsFieldName.CurrencyCode,
    });

    const enterpriseId = useCurrentEnterpriseId();

    return (
        <DividerList spacing="400">
            <ContentSection title={lt('RateGroupConfiguration')} description={lt('RateGroupConfigurationDescription')}>
                <SettlementConfigurationFields enterpriseId={enterpriseId} />
            </ContentSection>
            <ContentSection
                title={lt('RateGroupDefaultPolicySectionTitle')}
                description={lt('RateGroupDefaultPolicySectionDescription')}
            >
                <LocalPolicyFields settlementCurrencyCode={selectedCurrency} enterpriseId={enterpriseId} />
                <LocalCreatePolicyLinks />
            </ContentSection>
        </DividerList>
    );
};
